import React from 'react';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Textarea } from '@/components/shadcn/ui/textarea';
import { useForm } from 'react-hook-form';
import { Form, 
  FormControl, 
  FormField, 
  FormItem,
} from '@/components/shadcn/ui/form';
import { Button } from '@/components/shadcn/ui/button';

// todo: adiconar tipo para a função de edição de comentário
type FormComentarioProps = {
  onCommentSubmit: (index:number | undefined, data:any) => void;
  index: number | undefined;
  comment: {
    businessId: number,
    commentId: number,
    comment: string
  } | undefined,
};

const schema = z.object({
  id: z.number(),
  comment: z.string().max(100, { message: 'Limite de caracteres atingido' }),
});

const FormComment: React.FC<FormComentarioProps> = ({ onCommentSubmit, comment, index }) => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = form.getValues();
    // console.log(index);
    // console.log(formData);
    // Criar novo comentário
    if (!comment) {
      onCommentSubmit(undefined, formData);
      return;
    } else{
      onCommentSubmit(index, formData);
    }
  };

  let buttonText = 'Adicionar Comentário';

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
  });

  // atribuindo o valor do comentário à ser atualizado no input
  if (comment) {
    buttonText = 'Editar comentário';
    form.setValue('id', comment.commentId);
    // form.setValue('comment', comment.comment);
  }

  return (
    <div className='py-4'>
      <Form {...form}>
        <form onSubmit={handleSubmit} className='py-2 flex flex-col gap-2'>
          <FormField
            control={form.control}
            name="comment"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    defaultValue={comment?.comment}
                    placeholder="Escreva um comentário"
                    className="resize-none"
                    {...field}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <Button type='submit' className=' my-4 self-end'>{buttonText}</Button>
        </form>
      </Form>
    </div>
  );
};

export default FormComment;
